import React, { memo } from 'react';

// Redirect
import { Link } from 'react-router-dom';

// Lib
import { sanitize } from 'dompurify';
import { decodeHtmlEntity } from 'lib/helpers';

// Type
import { IColumn } from '../type';
import { UnitLibraries } from 'pages/Libraries/type';
import { TreeNode } from 'pages/Thesaurus/Thesaurus';

// Components
import Img from 'components/Img';

const getName = (str: string) => {
	return <span dangerouslySetInnerHTML={{
		__html: sanitize(decodeHtmlEntity(str || '') || '')
	}} />;
};

const Column: React.FC<IColumn> = memo((props) => {
	let list = <></>;

	const {
		alt,
		src,
		data,
		title,
		ulClass,
		imgClass,
		linkClass,
		titleClass,
		calcNumber,
		wrapperClass,
		imgArrowClass,
		children = {},

		titleId,

		link,
		isProducts = false
	} = props;

	const toTitle = isProducts ? link : `/libraries?anchor=${titleId}`;

	if (!isProducts) {
		list = <>
			{!!data?.length && data.map((x: UnitLibraries, j: number) => {
				return (
					<Link
						className={linkClass}
						to={`/libraries-product/${x.catNumber}`}
						key={`${x.name}__` + (j * (calcNumber || 0))}
					>
						{getName(x.name || '')}
						{imgArrowClass && <Img
							alt="Arrow icon"
							name="arrowRight"
							className={imgArrowClass}
						/>}
					</Link>
				);
			})}
		</>;
	}

	if (isProducts) {
		list = <>
			{!!data?.length && data.map((x: TreeNode, j: number) => {
				const treeNodeItem = {
					...x?.extra,
					value: x?.value,
					selectedKeys: [x.value],
					expandedKeys: x?.expandedKeys || []
				};

				return (
					<Link
						className={linkClass}
						state={{ item: treeNodeItem || x }}
						to={`/categorized-products/${encodeURIComponent(treeNodeItem.name || '')}`}
						key={`${x?.name}__` + (j * (calcNumber || 0))}
					>
						{getName(x?.name || x?.extra?.name || '')}
					</Link>
				);
			})}
		</>;
	}

	return (
		<div className={wrapperClass}>
			<Img
				alt={alt}
				// @ts-ignore
				name={src}
				className={imgClass}
			/>

			<Link to={toTitle || ''}>
				<h4
					className={titleClass}
					dangerouslySetInnerHTML={{ __html: sanitize(title || '') }}
				/>
			</Link>

			<ul className={ulClass}>
				{list}
			</ul>

			{!!Object.keys(children)?.length && <div className={wrapperClass}>
				<Img
					name={children.src}
					alt={children.alt}
					className={imgClass}
				/>

				<Link to={`/libraries?anchor=${children.titleId}`}>
					<h4
						className={titleClass}
						dangerouslySetInnerHTML={{ __html: sanitize(children.title || '') }}
					/>
				</Link>

				<ul className={`${ulClass} mt10`}>
					{!!children?.data && children?.data?.map((x: UnitLibraries, j: number) => {
						return (
							<Link
								className={linkClass}
								to={`/libraries-product/${x.catNumber}`}
								key={`${x.name}__` + (j * (calcNumber || 0))}
							>
		           <span dangerouslySetInnerHTML={{
								 __html: sanitize(decodeHtmlEntity(x.name || '') || '')
							 }} />
								{imgArrowClass && <Img
									alt="Arrow icon"
									name="arrowRight"
									className={imgArrowClass}
								/>}
							</Link>
						);
					})}
				</ul>
			</div>}
		</div>
	);
});

export default Column;
